import {componentsHelper} from './_helper'

export default [
  {
    path: '/checkout',
    ...componentsHelper('checkout/index')
  },
  {
    path: '/checkout/shipping',
    ...componentsHelper('checkout/shipping')
  },
  {
    path: '/checkout/checkout',
    ...componentsHelper('checkout/checkout')
  },
  {
    path: '/checkout/completed',
    ...componentsHelper('checkout/completed')
  }
]



// WEBPACK FOOTER //
// ./client/router/checkout.js